// extracted by mini-css-extract-plugin
module.exports = {"aboutWrapper":"about-module--aboutWrapper--1KmrP"};